export default __webpack_public_path__ + "static/media/copy-icon.1b9a5c19.svg";